<div class="col-lg-12 kanban-board p-3 pt-0 pb-0">
  <div class="Container Flipped">
    <div class="Content">
      <div class="scroll-box week-screen">
        <div
          class="col-lg-3 week-col"
          *ngFor="let entry of getActiveListingArray(); trackByKey"
          pDroppable
          (onDrop)="drop(entry.key)">
          <div class="grid-col p-2">
            <h2 class="mb-2">{{ getNameByTaskStatusFromEnums(entry.key) }}</h2>
            <div class="card-scroll">
              <div
                class="ticket-card p-3"
                *ngFor="let product of entry.value; let i = index"
                pDraggable
                (onDragStart)="dragStart(product)"
                [ngClass]="{ 'mb-3': i !== entry.value.length - 1 }">
                <div
                  (click)="redirectToTaskSummary(product.taskId)"
                  *ngIf="
                    !product.isExternal || product.isAdmin;
                    else isExternalCard
                  ">
                  <div
                    class="d-flex align-items-center justify-content-between mb-2">
                    <p-tag
                      *ngIf="isPriorityType(product.priorityType)"
                      [ngClass]="{
                        red: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Urgent
                        ),
                        blue: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Source
                        ),
                        yellow: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Order
                        ),
                        green: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Standard
                        ),
                      }">
                      {{ product.priorityTypeText }}
                    </p-tag>

                    <span class="task-name">{{ product.taskTypeText }}</span>
                  </div>
                  <span class="card-hd"
                    >{{
                      product.projectWorkflowId === null &&
                      product.customerNameWithNoProject
                        ? product.customerNameWithNoProject
                        : product.clientName
                    }}
                  </span>
                  <div
                    class="d-flex align-items-center justify-content-between mb-2">
                    <div class="col-lg-11 d-flex align-items-center gap-2">
                      <div class="ticket-number">
                        {{ product.projectWorkflowId }}
                      </div>
                      <div
                        class="ticket-details col-lg-9 text-truncate"
                        pTooltip="{{ product.title }}"
                        tooltipPosition="top">
                        {{ product.title }}
                      </div>
                      <span
                        class="infoico-circle"
                        *ngIf="product.hasDescription"
                        (click)="redirectToTaskSummary(product.taskId)"
                        ><i class="pi pi-info-circle"></i
                      ></span>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-2 mt-2 tag-bar">
                    <div class="d-flex gap-1 align-items-center mb-1">
                      <div class="hdi-bar">
                        <i class="pi pi-clock"></i>IHD :
                      </div>
                      <div class="hdi-date">
                        {{ product.ihd | date: "MMM d, y" }}
                      </div>
                    </div>
                    <div
                      class="embroided-bar text-truncate"
                      *ngIf="product.jobName.trim() !== ''">
                      <i class="pi pi-shopping-bag"></i>{{ product.jobName }}
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between">
                    <div class="d-flex gap-2 align-items-center">
                      <div class="green-circle">
                        <div
                          *ngIf="product.assignedTo.trim() !== ''"
                          class="circle-name"
                          [style.color]="getTextColor(product.assignedTo)"
                          [style.background]="getColor(product.assignedTo)"
                          (mouseenter)="
                            showAvatarPopover(
                              $event,
                              product.assignedToUserId,
                              product.assignedTo
                            )
                          "
                          (mouseleave)="hideAvatarPopover()">
                          {{ product.assignedTo.charAt(0) }}
                        </div>
                      </div>
                      <div class="event-title-tag">
                        <i class="pi pi-circle-fill"></i> Sales
                      </div>
                    </div>
                    <div
                      class="ticket-chat-link d-flex align-items-center justify-content-between gap-2">
                      <div
                        class="chat-link-text d-flex align-items-center justify-content-between gap-1">
                        <div class="icon"><i class="pi pi-comment"></i></div>
                        <p class="m-0">{{ product.commentsCount }}</p>
                      </div>

                      <div
                        class="chat-link-text d-flex align-items-center justify-content-between gap-1">
                        <div class="icon"><i class="pi pi-link"></i></div>
                        <p class="m-0">{{ product.attachmentCount }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #isExternalCard>
                  <div class="d-flex align-items-center gap-2 mb-2">
                    <p-tag
                      *ngIf="product.priorityType"
                      [ngClass]="{
                        red: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Urgent
                        ),
                        yellow: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Source
                        ),
                        blue: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Order
                        ),
                        green: isTaskPriority(
                          product.priorityType,
                          PriorityTypeEnums.Standard
                        ),
                      }">
                      {{ product.priorityTypeText }}
                    </p-tag>

                    <span class="task-name-loader">
                      <p-skeleton
                        width="70%"
                        class="board-loader01"
                        animation="none"></p-skeleton>
                    </span>
                  </div>
                  <p-skeleton
                    width="50%"
                    class="board-loader02"
                    animation="none"></p-skeleton>
                  <p-skeleton
                    width="100%"
                    class="board-loader03"
                    animation="none"></p-skeleton>
                  <p-skeleton
                    width="60%"
                    class="board-loader03"
                    animation="none"></p-skeleton>
                  <div
                    class="d-flex align-items-center justify-content-between">
                    <div class="green-circle">
                      <div
                        *ngIf="product.assignedTo.trim() !== ''"
                        class="circle-name"
                        [style.color]="getTextColor(product.assignedTo)"
                        [style.background]="getColor(product.assignedTo)"
                        (mouseenter)="
                          showAvatarPopover(
                            $event,
                            product.assignedToUserId,
                            product.assignedTo
                          )
                        "
                        (mouseleave)="hideAvatarPopover()">
                        {{ product.assignedTo.charAt(0) }}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <p-dialog
  [(visible)]="displayTaskDetailModal"
  (onHide)="closeTaskDetailModal()"
  class="summary-popup"
  [style]="{ width: '60%', height: '80%', maxHeight: '100%' }"
  appendTo="body">
  <jni-task-summary
    *ngIf="displayTaskDetailModal"
    [showTaskHeader]="showEditTaskModal"
    (closeAddTask)="closeTaskDetailModal()"
    [taskIdSelected]="taskIdSelected"></jni-task-summary>
</p-dialog> -->

<!-- <jni-task-summary
  *ngIf="displayTaskDetailModal"
  [displayTaskDetailModal]="displayTaskDetailModal"
  [showTaskHeader]="showEditTaskModal"
  (closeAddTask)="closeTaskDetailModal()"
  (closeTaskDetailModalEvent)="closeTaskDetailModal()"
  [taskIdSelected]="taskIdSelected">
</jni-task-summary> -->

<jni-task-header-edit
  #taskHeaderEdit
  *ngIf="displayTaskDetailModal"
  [displayModal]="displayTaskDetailModal"
  [showTaskHeader]="showEditTaskModal"
  (closeAddTask)="closeTaskDetailModal($event)"
  (showContact)="showContactDialog($event)"
  [taskIdSelected]="taskIdSelected"
  [actionType]="'Edit'">
</jni-task-header-edit>
